import { render, staticRenderFns } from "./ShippedMaterialsStore.vue?vue&type=template&id=06f5e1e6&scoped=true"
import script from "./ShippedMaterialsStore.vue?vue&type=script&lang=js"
export * from "./ShippedMaterialsStore.vue?vue&type=script&lang=js"
import style0 from "./ShippedMaterialsStore.vue?vue&type=style&index=0&id=06f5e1e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f5e1e6",
  null
  
)

export default component.exports